interface GetPromoIterationCountConfig {
  subscriptionIterations?: number;
  firstPaymentCycles?: number;
}

export const getPromoMonthsLeftAfterFirstPayment = (
  config?: GetPromoIterationCountConfig
) => {
  const { subscriptionIterations = 0, firstPaymentCycles = 0 } = config || {};
  const res = subscriptionIterations
    ? subscriptionIterations -
      /**
       * subscription iterations includes the current month. So if it is 7 we should say "Next 6 month" that is why there is "1 +" in the extraction part
       * firstPaymentCycles refers to how many months are included in the first payment. If it is 0 it is only the current month.
       * If it is 1 current month plus next month, if it is 2 current month and next 2 months.
       * So it is also needed to be extracted from subscription iterations because the discount is already included in the first payment
       */
      (1 + firstPaymentCycles)
    : 0;

  return res > 0 ? res : 0;
};
